(function(){
"use strict";

const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
// K2 no tiene packs en Kaching: el botón del cierre y el de la barra fija agregan el frasco con el botón nativo
document.addEventListener("click", e => {
  if (!e.target.closest(".lp [data-go-buy], #sBtn")) return;
  const btn = document.querySelector("product-form [type=submit], .product-form [name=add]");
  if (btn) btn.click();
});
// Despacho según la hora de Santiago
function despacho(){
  let h = 12;
  try { h = +new Intl.DateTimeFormat("es-CL", {timeZone:"America/Santiago", hour:"numeric", hourCycle:"h23"}).format(new Date()); } catch(e) {}
  const DIAS = ["domingo","lunes","martes","miércoles","jueves","viernes","sábado"];
  let d = new Date();
  try { const p = Object.fromEntries(new Intl.DateTimeFormat("en-US", {timeZone:"America/Santiago", year:"numeric", month:"numeric", day:"numeric"}).formatToParts(d).map(x => [x.type, x.value])); d = new Date(+p.year, +p.month - 1, +p.day); } catch(e) {}
  if (h >= 12) d.setDate(d.getDate() + 1);
  const txt = `Llega ${h < 12 ? "hoy" : "mañana"} ${DIAS[d.getDay()]} ${d.getDate()} (RM)`;
  document.querySelectorAll("[data-ship]").forEach(el => el.textContent = txt);
}
despacho(); setInterval(despacho, 60000);

// Etiqueta
const lm = document.getElementById("labelModal"); let lastFocus = null;
if (lm) {
  document.querySelectorAll("[data-label]").forEach(b => b.addEventListener("click", () => { lastFocus = b; lm.hidden = false; document.getElementById("labelClose").focus(); }));
  const closeLm = () => { lm.hidden = true; if (lastFocus) lastFocus.focus(); };
  document.getElementById("labelClose").addEventListener("click", closeLm);
  lm.addEventListener("click", e => { if (e.target === lm) closeLm(); });
  document.addEventListener("keydown", e => { if (e.key === "Escape" && !lm.hidden) closeLm(); });
}
if (reduce) document.querySelectorAll(".lp video").forEach(v => { v.removeAttribute("autoplay"); v.pause(); });

// Barra fija: aparece solo cuando no hay otra compra a la vista (sin ruido de botones)
(function(){
  const bar = document.querySelector(".lp .sticky"); if (!bar) return;
  const zones = () => [document.querySelector(".product__info-container"), document.querySelector(".lp-galeria"), ...document.querySelectorAll(".lp .strip"), document.querySelector(".lp .final")].filter(Boolean);
  const update = () => {
    const vh = window.innerHeight || document.documentElement.clientHeight;
    const hide = zones().some(z => { const r = z.getBoundingClientRect(); return r.bottom > 0 && r.top < vh - 40; });
    bar.classList.toggle("is-hidden", hide); bar.toggleAttribute("inert", hide);
  };
  addEventListener("scroll", update, {passive: true}); addEventListener("resize", update);
  update();
})();

// Galería propia: se mueve a la columna de fotos del theme y se arma el carrusel
(function(){
  const g = document.querySelector(".lp-galeria"), mw = document.querySelector(".product__media-wrapper");
  if (g && mw) { mw.prepend(g); document.documentElement.classList.add("lp-gal-ok"); }
  const tr = document.getElementById("track"); if (!tr) return;
  const slides = [...tr.children], n = slides.length;
  const dots = document.getElementById("dots"), th = document.getElementById("thumbs"), cnt = document.getElementById("gcount");
  dots.innerHTML = slides.map((s, i) => `<button class="dot" data-go-slide="${i}" aria-label="Ir a: ${s.dataset.name}"></button>`).join("");
  th.innerHTML = "";
  slides.forEach((s, i) => {
    const b = document.createElement("button"); b.className = "th"; b.dataset.goSlide = i; b.setAttribute("aria-label", "Ir a: " + s.dataset.name);
    const c = s.cloneNode(true); c.setAttribute("aria-hidden", "true"); c.removeAttribute("data-name");
    c.querySelectorAll("video").forEach(v => { const im = document.createElement("img"); im.className = "vposter"; im.src = (s.querySelector("video") || {}).poster || ""; im.alt = ""; v.replaceWith(im); });
    c.querySelectorAll("button,[data-label]").forEach(x => { x.removeAttribute("data-label"); x.setAttribute("tabindex", "-1"); });
    b.appendChild(c); th.appendChild(b);
  });
  const step = () => (slides[1] ? slides[1].offsetLeft - slides[0].offsetLeft : tr.clientWidth);
  const idx = () => Math.round(tr.scrollLeft / step());
  const mark = () => { const k = idx(); cnt.textContent = (k + 1) + " / " + n; document.querySelectorAll("[data-go-slide]").forEach(b => b.setAttribute("aria-current", +b.dataset.goSlide === k ? "true" : "false")); };
  const goS = k => { k = (k + n) % n; tr.scrollTo({left: k * step()}); };
  tr.addEventListener("scroll", mark, {passive:true});
  tr.addEventListener("keydown", e => { if (e.key === "ArrowRight") goS(idx() + 1); if (e.key === "ArrowLeft") goS(idx() - 1); });
  document.addEventListener("click", e => {
    const d = e.target.closest("[data-go-slide]"); if (d) { goS(+d.dataset.goSlide); return; }
    const g2 = e.target.closest("[data-gnav]"); if (g2) goS(idx() + +g2.dataset.gnav);
  });
  mark();
})();

})();